<template>
  <div :class="componentClassName">
    <div class="m-special-business-day-setting-item__header">
      <div class="m-special-business-day-setting-item__title">特別営業日{{ itemNumber }}</div>
      <div class="m-special-business-day-setting-item__remove-button">
        <a-button
          variant="round"
          size="small"
          label="削除"
          color="grey"
          icon="trash"
          :inline="true"
          @click="handleItemRemoveClick"
        />
      </div>
    </div>
    <div class="m-special-business-day-setting-item__fields">
      <m-form-input label="営業日設定">
        <a-calendar-field v-model="day" @change="handleChange" />
      </m-form-input>
      <m-form-input label="営業時間設定">
        <div class="m-special-business-day-setting-item__options">
          <div v-if="periodList.length > 0" class="m-special-business-day-setting-item__list">
            <div
              v-for="(item, index) in periodList"
              :key="index"
              class="m-special-business-day-setting-item__list-item"
            >
              <div class="m-special-business-day-setting-item__list-item-period">
                <a-business-hour-input-field
                  v-model="periodList[index]"
                  :item-index="index"
                  @remove="handlePeriodRemoveClick"
                  @change="handleChange"
                />
              </div>
            </div>
          </div>
          <div class="m-special-business-day-setting-item__options-config">
            <div class="m-special-business-day-setting-item__add-button">
              <a-button
                v-if="periodList.length < 3"
                variant="fill"
                size="small"
                label="営業時間を追加"
                color="primary"
                :inline="true"
                :disabled="currentIs24hours"
                @click="handleAddPeriodClick"
              />
            </div>
            <div class="m-special-business-day-setting-item__checkbox">
              <a-checkbox v-model="currentIs24hours" label="24時間営業" @change="handleChange" />
            </div>
          </div>
        </div>
      </m-form-input>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { cloneDeep } from 'lodash';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ACalendarField from '@/components/atoms/calendar-field';
import ACheckbox from '@/components/atoms/checkbox';
import ABusinessHourInputField from '@/components/atoms/business-hour-input-field';

export default {
  name: 'm-special-business-day-setting-item',
  components: {
    AButton,
    MFormInput,
    ACalendarField,
    ACheckbox,
    ABusinessHourInputField,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    modelValue: {
      type: [String, Array],
      default: null,
    },
    is24hours: {
      type: Boolean,
      default: false,
    },
    periods: {
      type: Array,
      default: new Array(0),
    },
  },
  emits: ['remove', 'update:modelValue', 'update:is24hours', 'update:periods', 'change', 'add:period', 'remove:period'],
  data() {
    return {
      day: '',
      currentIs24hours: false,
      periodList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-special-business-day-setting-item');
      return `${baseClassName} ${this.class}`.trim();
    },
    itemNumber() {
      return this.itemIndex + 1;
    },
  },
  watch: {
    modelValue(val) {
      this.day = val;
    },
    is24hours(val, oldValue) {
      this.currentIs24hours = val;
    },
    periods: {
      handler(val) {
        this.setCurrentPeriod(val);
      },
      deep: true,
      flush: 'sync',
    },
  },
  mounted() {
    if (this.is24hours !== null) {
      this.currentIs24hours = this.is24hours;
    }
    if (this.periods) {
      this.setCurrentPeriod(this.periods);
    }
    if (this.modelValue) {
      this.day = this.modelValue;
    }
  },
  methods: {
    handleItemRemoveClick() {
      this.$emit('remove', this.itemIndex);
    },
    handlePeriodRemoveClick(index) {
      this.periodList.splice(index, 1);
      this.$emit('update:periods', cloneDeep(this.periodList));
      this.$emit('remove:period', index);
    },
    handleAddPeriodClick() {
      this.periodList.push('');
      this.$emit('update:periods', cloneDeep(this.periodList));
      this.$emit('add:period');
    },
    setCurrentPeriod(periods) {
      this.periodList.splice(0);
      periods.forEach(period => {
        this.periodList.push(period);
      });
    },
    handleChange(e) {
      if (this.currentIs24hours) {
        // clear all existing period
        this.periodList.splice(0);
      }
      this.$emit('update:modelValue', this.day);
      this.$emit('update:is24hours', this.currentIs24hours);
      this.$emit('update:periods', cloneDeep(this.periodList));
      this.$emit('change', e);
    },
  },
};
</script>
